import request from "@/utils/request";

//  转签须知内容
export const signNote = () => {
  return request({
    url: "/treasure/ehr/changeSign/getNotes?type=1",
    method: "get"
  });
};
